import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import appReducer from "./slice/app";
import { authApi } from "./api/auth.api";
import { universityApi } from "./api/universities.api";
import { usersApi } from "./api/users.api";
import { cityApi } from "./api/cities.api";
import { settingsApi } from "./api/settings.api";

export const store = configureStore({
  reducer: {
    app: appReducer,
    [authApi.reducerPath]: authApi.reducer,
    [universityApi.reducerPath]: universityApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      universityApi.middleware,
      usersApi.middleware,
      cityApi.middleware,
      settingsApi.middleware
    ),
});

setupListeners(store.dispatch);
